import type { CSSProperties } from "react";

export function ConfirmDialog({
  title, message, confirmLabel = "Delete", danger = true, onConfirm, onClose,
}: {
  title: string;
  message: string;
  confirmLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}) {
  return (
    <div onClick={onClose} style={scrim}>
      <div onClick={(e) => e.stopPropagation()} style={sheet}>
        <h2 style={{ margin: "0 0 8px", fontSize: 17, fontWeight: 500 }}>{title}</h2>
        <p className="prose" style={{ margin: 0, fontSize: 13.5, color: "var(--ink3)" }}>{message}</p>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 9, marginTop: 20 }}>
          <button onClick={onClose} style={ghostBtn}>Cancel</button>
          <button
            onClick={() => { onConfirm(); onClose(); }}
            style={{ ...primaryBtn, background: danger ? "var(--warn)" : "var(--accent)" }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

const scrim: CSSProperties = { position: "fixed", inset: 0, background: "var(--scrim)", zIndex: 60, display: "flex", alignItems: "flex-start", justifyContent: "center", padding: "90px 20px", animation: "fadein 0.12s ease-out" };
const sheet: CSSProperties = { width: 400, maxWidth: "100%", background: "var(--raised)", borderRadius: 14, padding: "22px 24px", animation: "pop 0.15s ease-out", border: "1px solid var(--overlayLine)", boxShadow: "var(--shadowOverlay)" };
const primaryBtn: CSSProperties = { padding: "9px 16px", borderRadius: 8, border: "none", color: "var(--onAccent)", fontSize: 13, fontWeight: 500, cursor: "pointer" };
const ghostBtn: CSSProperties = { padding: "9px 14px", borderRadius: 8, border: "1px solid var(--line2)", background: "var(--surface)", color: "var(--ink2)", fontSize: 13, cursor: "pointer" };
